Ember.Application.initializer
  name: 'rollbar'

  initialize: (container, application) ->
    env = container.lookup('service:environment')

    return unless env.get('isProduction')

    window._rollbarConfig =
      accessToken: env.get('rollbarToken')
      captureUncaught: true
      verbose: true
      payload:
        environment: env.get('name')

    require 'utils/rollbar-snippet'
